import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {ImagePicker, List, TextareaItem, Toast, ActivityIndicator} from "antd-mobile";
import DefaultLayout from "../../components/DefaultLayout";
import UserCarService from "../../apiServices/UserCarService";
import BottomPanel from "../../components/BottomPanel";
import {notification} from "antd";
import ClaimService from "../../apiServices/ClaimService";
import {SelectField} from "react-md";
import InsuBrandService from "../../apiServices/InsuBrandService";

const Item = List.Item;

class CreateClaim extends Component {
    constructor(props){
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('object_id');

        this.state = {
            hasError: false,
            hiddenBtn: false,
            claims: null,
            object_id: object_id,
            userCar: null,
            description: null,
            car_img: [],
            insList: [],
            insurance_id: null,
            showLoading: true,
        };
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});
        UserCarService.detail(this.state.object_id).then(response=>{
            this.setState({
                userCar: response.data,
                brandLogo: response.data.car_brand.alias,
                insurance_id: response.data.insu_brand_id,
                showLoading: false
            });
        }).catch(function(error){
            console.log(error);
        });

        ClaimService.findByCarId(this.state.object_id).then(response=>{
            if(response.data !== null){
                this.props.history.push('/chi-tiet-khieu-nai?id='+response.data.id);
            }
        }).catch(function(error){
            console.log(error);
        });

        InsuBrandService.listBrand().then(response => {
            this.setState({insList: response.data});
        }).catch(function(error){
            console.log(error);
        });
    }

    onChangeCarImg = (car_img, type, index) => {
        this.setState({
            car_img,
        });
    };

    descriptionChange = (value) => {
        this.setState({description: value});
    };

    insBrandSelect = (value) => {
        this.setState({insurance_id: value});
    };

    formSubmit = () => {

        if(this.state.insurance_id===null){
            notification['error']({
                message: 'Bạn chưa chọn hãng Bảo hiểm',
                description: '',
            });
        }else if(this.state.description===null){
            notification['error']({
                message: 'Bạn cần mô tả thiệt hại',
                description: '',
            });
        }else if (this.state.car_img === []){
            notification['error']({
                message: 'Vui lòng upload ảnh sự việc',
                description: '',
            });
        }else{
            Toast.loading('Loading...', 60);
            ClaimService.create({
                'object_id': this.state.object_id,
                'insu_brand_id': this.state.insurance_id,
                'description': this.state.description,
                'claim_images': this.state.car_img,
            }).then(response => {
                Toast.hide();

                notification['success']({
                    message: 'Tạo yêu cầu bồi thường thành công',
                    description: 'Chúng tôi sẽ liên hệ lại với bạn trong vòng 3 phút',
                });

                this.setState({hiddenBtn: true});
                this.props.history.push('/');
            }).catch(error => {
                Toast.hide();
                this.setState({hiddenBtn: false});
                notification.error({
                    message: 'Không lưu được thông tin, vui lòng thử lại',
                    description: '',
                });
            });
        }
    };

    render() {
        let content;
        if (this.state.showLoading===true) {
            content = (<div className="wrap-content"><ActivityIndicator
                toast
                text="Loading..."
                animating={this.state.showLoading}
            /></div>);
        }else{
            let carInfo;
            if (this.state.userCar){
                let insuBrand;
                if (this.state.userCar.insu_brand_id > 0){
                    insuBrand = (<Item extra={(this.state.userCar.insu_brand)?this.state.userCar.insu_brand.name:''}>Hãng bảo hiểm</Item>);
                }else{
                    insuBrand = (<SelectField
                        id="select-insurance"
                        label="Chọn hãng Bảo hiểm?"
                        placeholder="Chọn hãng Bảo hiểm"
                        itemLabel="name"
                        itemValue="id"
                        menuItems={this.state.insList}
                        className="md-cell md-cell--12"
                        sameWidth
                        onChange={this.insBrandSelect}
                        position={SelectField.Positions.BOTTOM_LEFT}
                    />)
                }
                carInfo = (<List renderHeader={() => 'Thông tin xe'} className="od_header">
                    <Item extra={this.state.userCar.car_brand.name}>Hãng xe</Item>
                    <Item extra={this.state.userCar.car_product.name}>Dòng xe</Item>
                    <Item extra={this.state.userCar.plate_number}>Biển số xe</Item>
                    {insuBrand}
                </List>);
            }

            content = (<div className="wrap-content">
                {carInfo}

                <List renderHeader={() => 'Mô tả thiệt hại'}>
                    <TextareaItem className='txtDamage' onChange={e => this.descriptionChange(e)} rows={5} count={500}/>

                    <List.Item>
                        Hình ảnh
                        <ImagePicker
                            files={this.state.car_img}
                            onChange={this.onChangeCarImg}
                            accept="image/gif,image/jpeg,image/jpg,image/png"
                            selectable={this.state.car_img.length < 4}
                        />
                    </List.Item>
                </List>
            </div>);
        }

        return (<div className='App-block bgWhite' style={{minHeight: this.state.height}}>
            <DefaultLayout {...this.props} title="Tạo yêu cầu bồi thường" classNameContent="bgWhite" page_type={1} hiddenFt={true} showBottomPanel={true}>
                {content}
            </DefaultLayout>
            <BottomPanel handleClick={this.formSubmit} hidden={this.state.hiddenBtn} title={"Gửi yêu cầu"} actionType='submit'/>
        </div>);
    }
}

export default (withTranslation())(CreateClaim);